// Раздел «Инструмент» — обёртка с двумя табами: каталог (tool) и
// компоновки (drillstrings). Один rail-пункт, переключение внутри. Активная
// вкладка + id редактируемого/создаваемого элемента — в URL (search-параметрах
// роута /tools, см. router/routes/tools.route.tsx). Родитель прокидывает
// колбеки навигации, чтобы ToolsPage не знал о роутере.
//
// editId полиморфный: string (uuid) для каталога, number (i32) для компоновок.
// Контракт с родителем: тот делегирует тип в зависимости от tab().

import { Show } from 'solid-js'
import type { Component } from 'solid-js'
import { ToolPage } from './ToolPage'
import { DrillstringPage } from './DrillstringPage'

export type ToolsTab = 'catalog' | 'drillstrings'

type ToolsPageProps = {
  tab:             ToolsTab
  /// Для catalog — uuid (string). Для drillstrings — i32 (number). null — нет открытого редактора.
  editId:          string | number | null
  create:          boolean
  onTabChange:     (tab: ToolsTab) => void
  /// Для catalog шлёт string, для drillstrings — number.
  onOpen:          (id: string | number) => void
  onCreate:        () => void
  onBack:          () => void
  // Глубокий линк из секции drillstring на инструмент в каталоге.
  onOpenTool:      (id: string) => void
}

export const ToolsPage: Component<ToolsPageProps> = (props) => {
  return (
    <div class="tools-page">
      <div class="tabs tools-tabs">
        <div
          class={'tab' + (props.tab === 'catalog' ? ' active' : '')}
          onClick={() => props.onTabChange('catalog')}
        >
          Каталог
        </div>
        <div
          class={'tab' + (props.tab === 'drillstrings' ? ' active' : '')}
          onClick={() => props.onTabChange('drillstrings')}
        >
          Компоновки
        </div>
      </div>
      <Show when={props.tab === 'catalog'}>
        <ToolPage
          toolId={typeof props.editId === 'string' ? props.editId : null}
          create={props.create}
          onOpen={(id) => props.onOpen(id)}
          onCreate={props.onCreate}
          onBack={props.onBack}
        />
      </Show>
      <Show when={props.tab === 'drillstrings'}>
        <DrillstringPage
          drillstringId={typeof props.editId === 'number' ? props.editId : null}
          create={props.create}
          onOpen={(id) => props.onOpen(id)}
          onCreate={props.onCreate}
          onBack={props.onBack}
          onOpenTool={props.onOpenTool}
        />
      </Show>
    </div>
  )
}
